// Mock data for Gamma Marine Limited website

export const companyInfo = {
  name: "GAMMA MARINE LIMITED",
  tagline: "Navigating Excellence in Marine Survey",
  phone: "+64 21 2314953",
  emails: {
    operations: "ops@gamma-marine.co.nz"
  },
  address: "Tauranga, Bay of Plenty Region, New Zealand",
  serviceArea: "New Zealand, Australia, Pacific Islands, and India"
};

export const services = [
  {
    id: 1,
    title: "Vessel Condition Survey",
    description: "Comprehensive assessment of vessel's structural integrity, machinery, and operational systems.",
    icon: "Ship",
    image: "https://images.unsplash.com/photo-1678038871388-da81fca10764"
  },
  {
    id: 2,
    title: "Lifting Gear Inspection",
    description: "Thorough inspection of cranes, hoists, and lifting equipment ensuring compliance with safety standards.",
    icon: "Anchor",
    image: "/lifting-gear.jpg"
  },
  {
    id: 3,
    title: "Container & Cargo Inspection",
    description: "Detailed examination of cargo condition, securing methods, and container integrity.",
    icon: "Package",
    image: "https://images.unsplash.com/photo-1713859288954-3314e2fcaa7a"
  },
  {
    id: 4,
    title: "On-Hire & Off-Hire Inspection",
    description: "Professional assessment during vessel charter transitions to document condition and verify compliance.",
    icon: "ClipboardCheck",
    image: "/port-liaison.avif"
  },
  {
    id: 5,
    title: "Accident & Damage Investigation",
    description: "Expert investigation and reporting of marine incidents, casualties, and damage assessments.",
    icon: "AlertCircle",
    image: "https://images.unsplash.com/photo-1630516467783-718bdd4bd06b"
  },
  {
    id: 6,
    title: "Bunker Surveys",
    description: "Accurate measurement and quality assessment of bunker fuel during bunkering operations.",
    icon: "Fuel",
    image: "https://images.unsplash.com/photo-1767420073545-fe0a1f78b022"
  },
  {
    id: 7,
    title: "Pre-Purchase Inspections",
    description: "Comprehensive vessel evaluation for prospective buyers to assess condition and value.",
    icon: "FileSearch",
    image: "https://images.unsplash.com/photo-1623944156546-ddd5bf10796e"
  },
  {
    id: 8,
    title: "P&I Surveys",
    description: "Protection and indemnity surveys for insurance claims and risk assessment.",
    icon: "Shield",
    image: "https://images.unsplash.com/photo-1547411713-d8b9c8d1eaa7"
  },
  {
    id: 9,
    title: "Tanker Cargo Survey",
    description: "Specialized surveys for liquid cargo operations including quantity and quality verification.",
    icon: "Droplet",
    image: "/tanker-cargo.jpg"
  },
  {
    id: 10,
    title: "Internal & External Audits",
    description: "Comprehensive audits ensuring compliance with maritime regulations and industry standards.",
    icon: "FileText",
    image: "/internal-audit.jpg"
  },
  {
    id: 11,
    title: "Cargo Lashing/Securing Inspections",
    description: "Expert verification of cargo securing arrangements and lashing equipment integrity.",
    icon: "Link",
    image: "/cargo-lashing.jpg"
  },
  {
    id: 12,
    title: "Vessel Technical Assistance",
    description: "Professional technical support and consultation for vessel operations and maintenance.",
    icon: "Settings",
    image: "https://images.unsplash.com/photo-1645932647969-6a92e3d6667f"
  },
  {
    id: 13,
    title: "Vessel Support & Shore Coordination",
    description: "Comprehensive procurement services for technical spare parts, vessel stores, and supplies to ensure smooth operations.",
    icon: "Package",
    image: "/vessel-support.jpg"
  },
  {
    id: 14,
    title: "Port & Vessel Liaison Services",
    description: "Expert coordination and communication services between vessels, port authorities, and shore-based operations.",
    icon: "Radio",
    image: "/port-liaison.avif"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Approved National Inspection Agency",
    description: "Officially approved by Maritime New Zealand, ensuring the highest standards of compliance and credibility.",
    icon: "BadgeCheck"
  },
  {
    id: 2,
    title: "Experienced Surveyors",
    description: "Our team consists of highly qualified marine surveyors with extensive hands-on industry experience across diverse maritime sectors.",
    icon: "Award"
  },
  {
    id: 3,
    title: "Global Compliance Standards",
    description: "We adhere to international maritime compliance standards, ensuring quality service worldwide.",
    icon: "Globe"
  },
  {
    id: 4,
    title: "Quality & Precision",
    description: "Committed to delivering accurate, detailed, and reliable inspection reports every time.",
    icon: "Target"
  },
  {
    id: 5,
    title: "Quick Response & Reporting",
    description: "Fast turnaround times with comprehensive, transparent reporting to meet your urgent needs.",
    icon: "Zap"
  },
  {
    id: 6,
    title: "Regional Expertise",
    description: "Deep understanding of Australia, New Zealand, and Pacific Islands maritime operations.",
    icon: "MapPin"
  }
];

export const coreValues = [
  {
    id: 1,
    title: "Safety",
    description: "Prioritizing safety in every inspection and operation",
    icon: "Shield"
  },
  {
    id: 2,
    title: "Integrity",
    description: "Maintaining honest and ethical practices",
    icon: "CheckCircle"
  },
  {
    id: 3,
    title: "Reliability",
    description: "Delivering dependable and consistent service",
    icon: "Clock"
  },
  {
    id: 4,
    title: "Compliance",
    description: "Adhering to all maritime regulations and standards",
    icon: "FileCheck"
  },
  {
    id: 5,
    title: "Innovation",
    description: "Embracing modern technology and best practices",
    icon: "Lightbulb"
  }
];

export const missionVision = {
  mission: "To deliver dependable, timely, and transparent marine inspection solutions across all sectors of the maritime industry.",
  vision: "To be recognized as a trusted global partner for quality and integrity in marine surveying."
};

export const director = {
  name: "Perminder Singh Oberoi",
  title: "Chief Engineer, MarEng., Marine Surveyor",
  role: "Director",
  email: "perminder@gamma-marine.co.nz"
};

export const trainingInstitute = {
  title: "Gamma Marine Training Institute",
  description: "In collaboration with City of Glasgow College (UK), we offer internationally recognized maritime education and professional development programs.",
  partner: "City of Glasgow College, UK"
};

// Form submission functions - BACKEND API
export const submitContactForm = async (formData) => {
  try {
    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
    console.log('Submitting to:', `${BACKEND_URL}/api/contact`);
    
    const response = await fetch(`${BACKEND_URL}/api/contact`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    console.log('Contact form response:', data);
    return data;
  } catch (error) {
    console.error('Error submitting contact form:', error);
    return { success: false, message: 'Failed to submit form. Please try again.' };
  }
};

export const submitQuoteForm = async (formData) => {
  try {
    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
    console.log('Submitting to:', `${BACKEND_URL}/api/quote`);
    
    const response = await fetch(`${BACKEND_URL}/api/quote`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...formData,
        service_type: formData.serviceType,
        vessel_type: formData.vesselType
      })
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    console.log('Quote form response:', data);
    return data;
  } catch (error) {
    console.error('Error submitting quote request:', error);
    return { success: false, message: 'Failed to submit request. Please try again.' };
  }
};
